"use client";
import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UpdatePwaCheck } from '@/redux/features/pwacheck-slice';

interface PWAStatusCheckerProps {
  children: ReactNode;
}



function PWAStatusChecker({ children }: PWAStatusCheckerProps) {
  const dispatch = useDispatch();


  useEffect(() => {
    function getUrlParam(param: string): string {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param) || '(not set)';
    }

    function getBrowserName(): string {
      const ua = navigator.userAgent;
      if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edge") === -1 && ua.indexOf("OPR") === -1) return "Chrome";
      if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) return "Safari";
      if (ua.indexOf("Firefox") > -1) return "Firefox";
      if (ua.indexOf("Edge") > -1) return "Edge";
      if (ua.indexOf("OPR") > -1) return "Opera";
      return "Unknown";
    }

    function checkPWAStatus() {
      console.log("inside checkPWAStatus");
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      // const storedBackendVersion = sessionStorage.getItem('backendVersion');
      // const storedFrontendVersion = sessionStorage.getItem('frontendVersion');


      if (isStandalone) {
        console.log("its pwa");
        dispatch(UpdatePwaCheck(true));
        localStorage.setItem('isPWA', 'true');
        document.title = "KARMA TICKETS -  Canada’s Favourite “No Crazy Fees” App Specializing in Game Day Deals!";
        const installTime = new Date().toISOString();
        localStorage.setItem('pwa_installed_at', installTime);
        localStorage.setItem('pwa_onboarding_shown', 'false');

        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
          event: 'pwa_installed_session',

          installation_status: 'standalone app',

          app_version: '2.0.0'
        });
        (window as any).dataLayer.push({
          event: 'pwa_installed',
          installed_at: installTime,
          device: navigator.userAgent,
          browser: getBrowserName(),
          utm_source: getUrlParam('utm_source'),
          utm_medium: getUrlParam('utm_medium'),
          utm_campaign: getUrlParam('utm_campaign'),
        });
      } else {
        console.log("not pwa");
        dispatch(UpdatePwaCheck(false));
        localStorage.setItem('isPWA', 'false');
        document.title = "KARMA TICKETS -  Canada’s Favourite “No Crazy Fees” Website Specializing in Game Day Deals!";
      }
    }

    checkPWAStatus();
  }, [dispatch]);

  return <>{children}</>; // Render children inside
}



export default PWAStatusChecker;

